import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  background: #bf1e2d;
  height: 47px;
  width: 274px;

  border-radius: 20px;
  border: 0;
  padding: 0 16px;
  color: #ffffff;
  margin-top: 20px;

  font-size: 1.6rem;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.3, '#BF1E2D')};
  }
`;
